import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TournamentService } from '../services/tournament.service';
import { of } from 'rxjs';
import { Tournament } from '../models/tournament';

export const tournamentDetailResolver: ResolveFn<Tournament | undefined> = (route) => {
  const tournamentService = inject(TournamentService);
  const id = route.paramMap.get('id');

  if(!id) return of(undefined);

  return tournamentService.getTournament(id);
};
